import { withFormik, type FormikProps } from "formik";
import * as yup from "yup";
import type { ChangeEvent } from "react";

import wilayas from "./wilayas";
import { FieldGroup, ControlTextarea, ControlText, ControlSelect } from "../../../ui";

interface ShippingFormValues {
  name: string;
  email: string;
  phone: string;
  address: string;
  wilaya: string;
  instructions: string;
}

interface ShippingFormOuterProps {
  formId: string;
  product: {
    wilaya?: string;
    shipping?: Partial<ShippingFormValues>;
  };
  user: {
    name: string;
    profile: {
      email: string;
    };
  };
  onSubmit: (values: ShippingFormValues) => void;
  onChangeWilaya: (wilaya: string) => void;
}

type ShippingFormProps = FormikProps<ShippingFormValues> &
  Pick<ShippingFormOuterProps, "onChangeWilaya" | "formId">;

const ShippingForm = ({
  values,
  errors,
  submitCount,
  handleChange,
  handleBlur,
  handleSubmit,
  onChangeWilaya,
  formId,
}: ShippingFormProps) => (
  <form id={formId} onSubmit={handleSubmit}>
    <FieldGroup label="Instructions de livraison">
      <ControlTextarea
        name="address"
        label="Addresse"
        value={values.address || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={submitCount > 0}
        error={errors.address}
      />

      <ControlSelect
        name="wilaya"
        label="Wilaya"
        value={values.wilaya}
        onChange={(event: ChangeEvent<HTMLSelectElement>) => {
          handleChange(event);
          onChangeWilaya(event.target.value);
        }}
        onBlur={handleBlur}
        touched={submitCount > 0}
        error={errors.wilaya}
        options={wilayas.map((wilaya) => {
          return {
            label: wilaya.name,
            value: wilaya.code,
          };
        })}
      />

      <ControlTextarea
        name="instructions"
        label="Instructions supplémentaires"
        value={values.instructions || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={submitCount > 0}
        error={errors.instructions}
      />
    </FieldGroup>

    <FieldGroup label="Information personnelles">
      <ControlText
        name="name"
        label="Nom et Prénoms"
        value={values.name || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={submitCount > 0}
        error={errors.name}
      />

      <ControlText
        name="phone"
        label="Numéro de téléphone"
        value={values.phone || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={submitCount > 0}
        error={errors.phone}
      />

      <ControlText
        name="email"
        label="Email"
        value={values.email || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={submitCount > 0}
        error={errors.email}
      />
    </FieldGroup>
  </form>
);

export default withFormik<ShippingFormOuterProps, ShippingFormValues>({
  mapPropsToValues: ({ product, user }) => ({
    name: user.name,
    email: user.profile.email,
    wilaya: product.wilaya || "16",
    address: product.shipping?.address || "",
    phone: product.shipping?.phone || "",
    instructions: product.shipping?.instructions || "",
  }),
  validationSchema: yup.object().shape({
    address: yup.string().required(),
    name: yup.string().required(),
    phone: yup.string().required(),
    email: yup.string().email().required(),
    wilaya: yup.string().required(),
  }),
  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  },
})(ShippingForm);
